export default __webpack_public_path__ + "static/media/Close.89af2762.svg";